import { render, staticRenderFns } from "./taskUrgent.vue?vue&type=template&id=c2d6e39c&scoped=true&"
import script from "./taskUrgent.vue?vue&type=script&lang=js&"
export * from "./taskUrgent.vue?vue&type=script&lang=js&"
import style0 from "./taskUrgent.vue?vue&type=style&index=0&id=c2d6e39c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2d6e39c",
  null
  
)

export default component.exports